import React, {useContext, useEffect, useState} from 'react';
import {NavBar} from 'Components/Nav/NavBar';
import s from './styles/BlogPost.module.scss';
import Footer from './Footer';
import {useLocation} from "react-router-dom";
import {Root} from "../../Api/Root";
import {getDeviceId, isLoggedIn, SessionContext} from "../../Utils/sessions";
import {BACKUP_BLOG_CONTENT} from "./Blogs";
import {logElementInteraction} from "../../Api/Utils/referral";

export const HelpArticle = () => {
    const {session} = useContext(SessionContext);
    const [blogContent, setBlogContent] = useState(undefined)
    const [recommendedBlogs, setRecommendedBlogs] = useState(undefined)
    const location = useLocation();
    const currentPath = location.pathname;
    const helpArticleUri = currentPath.split("/")
        .at(currentPath.split("/").length - 1)

    function openNewBlog(uri) {
        const href = window.location.href;
        window.location.href = (`${href.split('/')[0]}/help/${uri}`);
    }

    useEffect(() => {
        logElementInteraction( {
            elementId: `help::${helpArticleUri}::${isLoggedIn(session) ? 'authenticated' : 'public'}`,
            type: 'VIEW',
            deviceId: getDeviceId(),
            data: localStorage.getItem('userInfo'),
            source: 'WEB'
        }).then(() => {}).catch(() => {});
    }, [helpArticleUri, session])

    useEffect(() => {
        fetch(`https://cdn.cassy.dev/help/${helpArticleUri}.json`)
            .then(response => {
                if (!response.ok) {
                    if (BACKUP_BLOG_CONTENT[helpArticleUri]) {
                        setBlogContent(BACKUP_BLOG_CONTENT[helpArticleUri])
                    } else {
                        setBlogContent(undefined)
                    }
                }
                return response.json(); // Parse the JSON body
            })
            .then(data => {
                setBlogContent(data)
            })
            .catch(() => {
                if (BACKUP_BLOG_CONTENT[helpArticleUri]) {
                    setBlogContent(BACKUP_BLOG_CONTENT[helpArticleUri])
                } else {
                    setBlogContent(undefined)
                }
            });

    }, [helpArticleUri]);

    useEffect(() => {
        Root.bloggingApi.getRecommendedBlogs(helpArticleUri, getDeviceId(), session?.jwt).then((res) => {
            setRecommendedBlogs(res.data)
        }).catch(() => {
            setRecommendedBlogs([])
        })
    }, [helpArticleUri, session.jwt]);

    return <>
        <div>
            <header className={s.header}>
                <NavBar dark={true}/>
            </header>
            <div className={`${s.container} ${s.articleContainer} mt-4`}>
                <div className={`${s.contentWrapper} ${isLoggedIn(session) && s.authenticatedContentWrapper}`}>
                    <aside className={s.leftSidebar}>
                        <div className={s.tableOfContents}>
                            <h3 className={s.sidebarHeading}>Table of Contents</h3>
                            {blogContent ?
                                <>
                                    <ul className={s.sidebarUl}>
                                        {blogContent.paragraphs?.map((paragraph) =>
                                            <>
                                                {paragraph.heading &&
                                                    <li key={paragraph.heading.id}>
                                                        <a href={`#${paragraph.heading.id}`}>
                                                        <span
                                                            className={s.tableOfContentsHeader}>{paragraph.heading.title}</span>
                                                        </a>
                                                    </li>
                                                }
                                            </>
                                        )}
                                    </ul>
                                </> :
                                <>
                                    <div className={` ${s.textPlaceHolder} ${s.shimmerBg}`}></div>
                                    <div className={` ${s.textPlaceHolder} ${s.shimmerBg}`}></div>
                                    <div className={` ${s.textPlaceHolder} ${s.shimmerBg}`}></div>
                                </>}
                        </div>
                    </aside>

                    <main className={s.mainArticleContent}>
                        {blogContent ?
                            <>
                                <article className={s.articleCard}>
                                    <header className={s.articleHeader}>
                                        <h1 className={s.articleTitle}>
                                            {blogContent.title}
                                        </h1>
                                        <div className={s.articleControls}>
                                            <div className={s.articleMeta}>
                                                <img src={blogContent.author?.avatar}
                                                     alt={`${blogContent.author?.name} avatar`}
                                                     className={s.articleAuthorImg}/>
                                                <div>
                                                    <span>{blogContent.author?.name}</span>
                                                    <span>{new Date(blogContent.dateString).toDateString()}</span>
                                                    <span>{blogContent.duration} minute read</span>
                                                </div>
                                            </div>
                                        </div>
                                    </header>

                                    {blogContent.keyTakeaways &&
                                        <section className={s.keyTakeaways}>
                                            <h2>Key takeaways</h2>
                                            <ul>
                                                {blogContent.keyTakeaways?.map((takeaway, idx) =>
                                                    <li key={idx}>
                                                        {takeaway}
                                                    </li>
                                                )}
                                            </ul>
                                        </section>
                                    }

                                    {blogContent.heroImageUrl &&
                                        <figure className={s.articleFigure}>
                                            <img
                                                src={blogContent.heroImageUrl}
                                                alt={`${blogContent.title} Visual`}
                                                className={s.articleImage}/>
                                        </figure>
                                    }

                                    <section className={s.proseStyles}>
                                        {blogContent.paragraphs?.map((paragraph) =>
                                            <>
                                                {paragraph.imageUrl &&
                                                    <figure className={s.articleFigure}>
                                                        <img
                                                            src={paragraph.imageUrl}
                                                            alt="Crypto Staking Visual" className={s.articleImage}/>
                                                    </figure>
                                                }
                                                {paragraph.heading &&
                                                    <h2 id={paragraph.heading.id}>{paragraph.heading.title}</h2>}
                                                {paragraph.text && <p>{paragraph.text}</p>}
                                            </>
                                        )}
                                    </section>
                                </article>
                            </> :
                            <>
                                <article className={s.articleCard}>
                                    <header className={s.articleHeader}>
                                        <div className={` ${s.titlePlaceHolder} ${s.shimmerBg}`}/>
                                        <div className={` ${s.subtitlePlaceHolder} ${s.shimmerBg}`}/>
                                    </header>

                                    <section className={`${s.keyTakeawaysPlaceholder} ${s.shimmerBg}`}/>

                                    <section className={s.proseStyles}>
                                        <div className={` ${s.textPlaceHolder} ${s.shimmerBg}`}/>
                                        <div className={` ${s.textPlaceHolder} ${s.shimmerBg}`}/>
                                        <div className={` ${s.textPlaceHolder} ${s.shimmerBg}`}/>
                                        <div className={` ${s.textPlaceHolder} ${s.shimmerBg}`}/>
                                        <div className={` ${s.textPlaceHolder} ${s.shimmerBg}`}/>
                                    </section>
                                </article>
                            </>}
                    </main>

                    <aside className={s.rightSidebar}>
                        <div className={s.continuedReading}>
                            <h3 className={s.sidebarHeading}>Need more help?</h3>
                            <div className={s.recommendedItemContainer}>
                                {recommendedBlogs ?
                                    <>
                                        {recommendedBlogs.map((recommendedBlog, idx) =>
                                            <>
                                                <div role={'link'} key={idx}
                                                     onClick={() => openNewBlog(recommendedBlog.uri)}
                                                     className={s.recommendedItemCard}>
                                                    <img src={recommendedBlog.coverUrl}
                                                         alt="" className={s.recommendedItemCardImage}/>
                                                    <div className={s.recommendedItemCardContent}>
                                                        <p className={s.recommendedItemCardTitle}>
                                                            {recommendedBlog.title}
                                                        </p>
                                                        <p className={s.recommendedItemCardDescription}>
                                                            {recommendedBlog.description}
                                                        </p>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </> :
                                    <>
                                        <div className={s.recommendedItemCard}>
                                            <div className={`${s.recommendedItemCardImage} ${s.shimmerBg}`}/>
                                            <div className={s.recommendedItemCardContent}>
                                                <div className={` ${s.textPlaceHolder} ${s.shimmerBg}`}/>
                                                <div className={` ${s.textPlaceHolder} ${s.shimmerBg}`}/>
                                            </div>
                                        </div>
                                        <div className={s.recommendedItemCard}>
                                            <div className={`${s.recommendedItemCardImage} ${s.shimmerBg}`}/>
                                            <div className={s.recommendedItemCardContent}>
                                                <div className={` ${s.textPlaceHolder} ${s.shimmerBg}`}/>
                                                <div className={` ${s.textPlaceHolder} ${s.shimmerBg}`}/>
                                            </div>
                                        </div>
                                    </>}
                            </div>
                        </div>
                    </aside>
                </div>
            </div>
        </div>
        <Footer/>
    </>
}